import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Auth from '@Services/Auth';
import history from '@AppRoutes/history';
import AppStorage from '@Services/AppStorage';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import { paths } from '@AppRoutes/constants';
import { isShown as isGlobalSpinnerShown } from '@Containers/GlobalSpinner/GlobalSpinnerSelectors';
import { showGlobalSpinner, hideGlobalSpinner } from '@Containers/GlobalSpinner/GlobalSpinnerActions';
import withReducer from '@Hooks/withReducer';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import alertsLoad from './HOCs/AlertsLoad';
import { fetchAlerts, setMounted, setRefetch, processPageAlertsByAlertId } from './AlertsAction';
import { groupsIds, refetch } from './AlertsSelectors';
import { alertsReducerKey } from './AlertsConstants';
import alertsReducer from './AlertsReducer';
import Alerts from './Alerts';

function AlertsContainer(props) {
  useEffect(() => {
    const checkAccess = async () => {
      try {
        await Auth.getUpdatedUserPromise();
        const isLoggedIn = Auth.isLoggedIn();
        const isAnon = Auth.isAnonymousUser();
        if (isLoggedIn) {
          if (isAnon) {
            AppStorage.instance.set('revisitLastState', true);
            // redirect to login
            history.push(paths.LOGIN);
          }
        }
      } catch (e) {
        Logger.error(e);
      }
    };
    RouteChangeTracking.trackOnRouteChangeSuccess();
    checkAccess();
  }, []);
  return (
    <Alerts {...props} />
  );
}

function mapStateToProps(state) {
  return {
    groupsIds: groupsIds(state),
    isGlobalSpinnerShown: isGlobalSpinnerShown(state),
    refetch: refetch(state),
  };
}

const mapDispatchToProps = {
  fetchAlerts,
  showGlobalSpinner,
  hideGlobalSpinner,
  setMounted,
  setRefetch,
  processPageAlertsByAlertId,
};

const EnhancedAlertsContainer = compose(
  withCombinedRouteParams,
  withReducer(alertsReducerKey, alertsReducer, true),
  connect(mapStateToProps, mapDispatchToProps),
  alertsLoad
)(AlertsContainer);

export default EnhancedAlertsContainer;
